var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0689 11.097L4.33907 16.5137C4.02025 16.6248 3.71736 16.6005 3.43042 16.4408C3.14347 16.281 3 16.0484 3 15.7429V4.90952C3 4.60397 3.14347 4.37133 3.43042 4.21161C3.71736 4.05188 4.02025 4.02758 4.33907 4.13869L19.0689 9.55536C19.4674 9.70813 19.6667 9.96508 19.6667 10.3262C19.6667 10.6873 19.4674 10.9442 19.0689 11.097ZM4.91296 14.4929L16.2472 10.3262L4.91296 6.15952V9.07619L10.6518 10.3262L4.91296 11.5762V14.4929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentPlane);
export default __webpack_public_path__ + "static/media/sent_plane.590c963285d36d0204d82c322f980411.svg";
export { ForwardRef as ReactComponent };